<template>
  <div class="login-page">
    <el-card>
      <center>
        <img :src="img" class="logo" />
        <h4>Welcome Lvbit Spot Admin</h4>
      </center>
      <el-form :model="form" label-width="240px" ref="loginForm" @submit.native.prevent="showCaptcha">
        <el-form-item label="账号：" label-width="80px" :rules="{
          required: true,
          message: '请输入账号',
        }">
          <el-input v-model="form.account"></el-input>
        </el-form-item>
        <el-form-item label="密码：" label-width="80px" :rules="{
          required: true,
          message: '请输入密码',
        }">
          <el-input type="password" v-model="form.password"> </el-input>
        </el-form-item>
        <!-- <el-form-item
          class="phone-code-form-item"
          label="手机验证码："
          prop="code"
          :rules="{
            required: true,
            message: '请输入手机验证码',
          }"
        >
          <el-input v-model="form.code"></el-input>
          <el-button
            @click.prevent="handlePhoneCode"
            :disabled="!form.account || !enableSendPhoneCode"
          >
            <span v-if="!enableSendPhoneCode">{{ this.timeDelay }}s</span>
            <span v-if="enableSendPhoneCode">获取验证码</span>
          </el-button>
        </el-form-item> -->
        <!-- <el-form-item
          class="phone-code-form-item"
          label="谷歌验证码："
          label-width="110px"
          prop="gCode"
          :rules="{
            required: true,
            message: '请输入谷歌验证码',
          }"
        >
          <el-input v-model="form.gCode" @focus="focus($event)"></el-input>
         
        </el-form-item> -->

        <el-form-item class="actions">
          <el-button type="primary" native-type="submit" class="login-btn">
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-dialog :title="isShow ? '输入谷歌验证码' : '扫描下方二维码绑定谷歌验证'" :visible.sync="secondStepDialog" width="300px"
      :before-close="handleClose">
      <div style="margin-left: 70px" :class="{ box: isShow }">
        <img :src="qrCode" width="128px" height="128px" />
      </div>
      <div class="gCode">
        <el-form>
          <el-form-item label="验证码：" label-width="80px" :rules="[
            {
              required: true,
              message: '请输入验证码',
            },
          ]">
            <el-input v-model="form.verifyCode"></el-input>
          </el-form-item>
          <!-- <el-form-item label="验证码：">
        <el-input type="text" v-model="gCode"></el-input>
        </el-form-item> -->
        </el-form>
        <!-- <span class="textTip">输入验证码：</span>
        <el-input type="text" v-model="gCode"></el-input> -->
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancle">取 消</el-button>
        <el-button size="small" type="primary" @click="secondLogin">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cookies from 'js-cookie'
import { mapActions } from 'vuex'
import logo from '../src/assets/images/logo@2x.png'
import encrypt from '@/utils/encrypt'
import '@/lib/gt'
export default {
  name: 'LoginPage',
  data() {
    return {
      img: logo,
      gCode: '',
      form: {
        verifyCode: '',
        judgeToken: '',
      },
      timeDelay: 60,
      enableSendPhoneCode: true,
      secondStepDialog: false,
      isShow: true,
      qrCode: '',
      geetest: null,
      captchaObj: null,
    }
  },
  methods: {
    ...mapActions([
      'login',
      'getPhoneCode',
      'secondSuffix',
      'getUserInfo',
      'logout',
      'init',
    ]),

    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.form.verifyCode = ''
          done()
          this.secondStepDialog = false
        })
        .catch((_) => { })
    },
    cancle() {
      this.secondStepDialog = false
      this.form.verifyCode = ''
    },
    secondLogin() {
      this.secondSuffix({ ...this.form }).then((res) => {
        if (res.code == 0) {
          this.getUserInfo().then((res) => {
            if (res.code == 0) {
              // 将页面重定向参数写入store并进行跳转
              const redirectUrl = this.$route.query.redirectUrl
              if (redirectUrl) {
                const isDev = process.env.NODE_ENV === 'development'
                const token = cookies.get('admin-token')
                window.location.href = isDev ? 'http://localhost:8080' + redirectUrl + '?token=' + token : 'https://contract.lvbit.pro' + redirectUrl + '?token=' + token
              } else {
                this.$router.push({ path: '/home' })
              }
            }
            if (res.code == -1) {
              this.$message.error('服务异常，稍后重试')
              this.logout()
            }
          })
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    showCaptcha() {
      this.captchaObj && this.captchaObj.showCaptcha()
    },

    onSubmit() {
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          // this.$router.push({ path: "/home" });
          this.login({
            account: this.form.account,
            password: encrypt(this.form.password),
            geetest: JSON.stringify(this.geetest),
          }).then((res) => {
            this.form.judgeToken = res.data.judgeToken
            this.secondStepDialog = true
            if (res.data.isFirst === false) {
              this.isShow = true
            }
            if (res.data.isFirst === true) {
              this.isShow = false
              this.qrCode = res.data.qrCode
            }
            // this.$router.push({ path: "/home" });
          })
        }
      })
    },
    handlePhoneCode() {
      this.getPhoneCode(this.form.account).then(() => {
        this.$message.success('验证码已发送，请注意查收。')
        this.enableSendPhoneCode = false
        this.timeInterval()
      })
    },
    timeInterval() {
      const interval = setInterval(() => {
        this.timeDelay--
        if (this.timeDelay === 0) {
          this.enableSendPhoneCode = true
          this.timeDelay = 60
          clearInterval(interval)
        }
      }, 1000)
    },
  },
  created() {
    this.init().then(({ gt, new_captcha, type }) => {
      // if (!new_captcha) return
      initGeetest4(
        {
          captchaId: gt,
          product: 'bind',
          language: 'zho',
        },
        (captcha) => {
          this.captchaObj = captcha
          // captcha为验证码实例
          // setCaptchaObj(captcha);
          captcha
            .onReady(() => {
              // 验证码ready之后才能调用verify方法显示验证码
            })
            .onSuccess(() => {
              const result = captcha.getValidate()
              this.geetest = result
              this.onSubmit()
              // if (!result) {
              //   return alert('请完成验证');
              // }
            })
            .onError(() => {
              // your code
            })
        }
      )
    })
  },
}
</script>

<style lang="less" scoped>
.logo {
  width: 160px;
  height: 80px;
}

.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  background: #edf2f8;
}

.login-page .el-card {
  padding: 20px;
  min-width: 450px;
}

.actions {
  margin-bottom: 0;
}

.actions /deep/ .el-form-item__content {
  margin-left: 0 !important;
}

.login-btn {
  width: 100%;
  font-size: 16px;
}

.forget-link {
  font-size: 14px;
  float: right;
}

.phone-code-form-item {
  /deep/ .el-form-item__content {
    display: flex;
    align-items: flex-start;

    .el-input {
      .el-input__inner {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }

    .el-button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-left: 0;
      width: 115px;
    }
  }
}

/deep/.el-dialog__title {
  font-size: 12px;
}

.gCode {
  height: 30px;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .textTip {
    width: 100px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
}

.box {
  display: none;
}
</style>
